// extracted by mini-css-extract-plugin
module.exports = {"embedContainer":"EditorEmbed_embedContainer__jipJP","embedComponent":"EditorEmbed_embedComponent__XI_aY","iframeContainer":"EditorEmbed_iframeContainer__jBcIJ"};